import { useTranslation } from "react-i18next";
import { ShipmentMethodEnum } from "../../../enums/shipmentMethod";

interface Props {
    value: ShipmentMethodEnum
}

const ShipmentMethodChip = ({ value }: Props) => {
    const { t } = useTranslation("global");
    return <span style={{ 
        backgroundColor: value === ShipmentMethodEnum.DELIVERY ? '#36B37E29' : '#FF563029',
        color: value === ShipmentMethodEnum.DELIVERY ? '#1B806A' : '#B71D18',
        borderRadius: "6px",
        padding: "2px 8px",
        lineHeight: 3,
    }}>
        {
            value=== ShipmentMethodEnum.DELIVERY ? t("Delivery") : value === ShipmentMethodEnum.PICK_UP ? t("Pick Up") : value
        }
    </span>
   
}
export default ShipmentMethodChip;